import React, {useMemo} from "react";
import moment from "moment";
import {StatStrip} from "../../../dashboard/components/StatTile";
import {campaignEnd, campaignStart, campaignState} from "./calendarUtils";

const count = (campaign, status) => Number(campaign.statusCounts?.[status]) || 0;

export const CampaignStatTiles = ({campaigns, month}) => {
  const stats = useMemo(() => {
    const today = moment().startOf("day");
    const weekEnd = today.clone().add(6, "days");
    const monthStart = month.clone().startOf("month");
    const monthEnd = month.clone().endOf("month");
    const running = campaigns.filter(campaign => campaignState(campaign) === "RUNNING");
    const startingSoon = campaigns.filter(campaign => {
      const start = campaignStart(campaign);
      return campaignState(campaign) === "SCHEDULED" && !start.isAfter(weekEnd, "day");
    });
    const open = campaigns.filter(campaign => campaignState(campaign) !== "FINISHED");
    const inMonth = campaigns.filter(campaign =>
      !campaignEnd(campaign).isBefore(monthStart, "day") && !campaignStart(campaign).isAfter(monthEnd, "day"));
    return {
      running: running.length,
      startingSoon: startingSoon.length,
      toCall: open.reduce((sum, campaign) => sum + count(campaign, "NOT_CALLED") + count(campaign, "QUEUED"), 0),
      answered: inMonth.reduce((sum, campaign) => sum + count(campaign, "ANSWERED"), 0),
      failed: inMonth.reduce((sum, campaign) => sum + count(campaign, "FAILED"), 0),
    };
  }, [campaigns, month]);

  return (
    <StatStrip items={[
      {label: "Active now", value: stats.running.toLocaleString(), note: stats.running ? "Calling today" : "Nothing running"},
      {label: "Starting this week", value: stats.startingSoon.toLocaleString(), note: "Next 7 days"},
      {label: "Left to call", value: stats.toCall.toLocaleString(), note: "Open campaigns"},
      {label: `Answered in ${month.format("MMMM")}`, value: stats.answered.toLocaleString(), note: `${stats.failed.toLocaleString()} failed`},
    ]}/>
  );
};
